<template>
  <emd-modal
    has-header
    :open="open"
    @close="togglePixModal"
  >
    <template v-slot:header>
      <h2 class="emd-text _size_section _color_secondary">
        {{ $t('charge.detail.payment-method.pix.modal.title') }}
      </h2>
    </template>
    <template v-slot:content>
      <div class="eu-mt_4">
        <p>{{ $t('charge.detail.payment-method.pix.modal.subtitle') }}</p>
        <p class="emd-text _color_default _type_caption eu-mb_1">
          {{ $t('charge.detail.payment-method.pix.modal.description') }}
        </p>
      </div>
      <div class="eu-py_6 eu-align_center">
        <img
          :src="qrCodeUrl"
          alt="QR code url"
        />
      </div>
      <p>
        {{
          $t('charge.detail.payment-method.pix.modal.charge', {
            charge: chargeId
          })
        }}
      </p>
    </template>
  </emd-modal>
</template>

<script>
import { EmdModal } from 'emerald-vue/src/components'

export default {
  name: 'ChargesPaymentMethodPixModal',

  components: {
    EmdModal
  },

  props: {
    chargeId: {
      required: true
    },
    qrCodeUrl: {
      required: true
    },
    open: {
      required: true
    }
  },

  methods: {
    togglePixModal () {
      this.$emit('handleOpen', !this.open)
    }
  }
}
</script>
